import SamaritanFetch from "./httpClient";

export const fetchMonthlySummary = () =>
  SamaritanFetch.v2(`/data/monthly_summary`);
